document.addEventListener('DOMContentLoaded', function() {
  if (!customElements.get('product-accessories-manager')) {
    customElements.define('product-accessories-manager', ProductAccessoriesManager);
  }
});

class ProductAccessoriesManager extends HTMLElement {
  constructor() {
    super();
    this.selectedAccessories = new Map();
    this.mainFormId = this.dataset.mainFormId || null;
  }

  connectedCallback() {
    if (!this.mainFormId) {
      this.mainFormId = this.findMainFormId();
    }
    
    this.initializeButtons();
    
    // 🆕 TOUJOURS configurer les listeners de quantité
    this.setupQuantityListener();
    
    setTimeout(() => {
      this.listenToMainForm();
    }, 100);
  }

  findMainFormId() {
    const mainForm = document.querySelector('form[action*="/cart/add"]') || 
                     document.querySelector('[data-product-form]') ||
                     document.querySelector('product-form form');
    
    if (mainForm) {
      if (!mainForm.id) {
        mainForm.id = 'main-product-form-' + Date.now();
      }
      return mainForm.id;
    }
    
    return null;
  }

  initializeButtons() {
    const addButtons = this.querySelectorAll('.product-accessory-item__add-btn');
    
    addButtons.forEach(button => {
      button.addEventListener('click', this.handleAccessoryToggle.bind(this));
    });
  }

  handleAccessoryToggle(event) {
    event.preventDefault();
    
    const button = event.currentTarget;
    const variantId = button.dataset.variantId;
    
    if (!variantId) return;

    const accessoryData = {
      productId: button.dataset.productId,
      variantId: parseInt(variantId),
      title: button.dataset.productTitle,
      price: parseFloat(button.dataset.productPrice) || 0
    };

    if (this.selectedAccessories.has(variantId)) {
      this.selectedAccessories.delete(variantId);
      this.setButtonUnselected(button);
    } else {
      this.selectedAccessories.set(variantId, accessoryData);
      this.setButtonSelected(button);
    }

    this.dispatchEvent(new CustomEvent('accessories-changed', {
      detail: {
        selectedCount: this.selectedAccessories.size,
        selectedAccessories: Array.from(this.selectedAccessories.keys()),
        accessoriesData: Array.from(this.selectedAccessories.values())
      },
      bubbles: true
    }));
  }

  setButtonSelected(button) {
    button.classList.add('selected');
    
    // Afficher la quantité au lieu du check
    const mainQuantity = this.getMainProductQuantity();
    button.innerHTML = mainQuantity;
    
    button.style.backgroundColor = '#151F34';
    button.style.borderColor = '#151F34';
    button.style.color = 'white';
    button.style.animation = 'accessorySelected 0.4s ease';
  }

  getMainProductQuantity() {
    const quantityInput = document.querySelector('quantity-selector .quantity-selector__input');
    return quantityInput ? parseInt(quantityInput.value) || 1 : 1;
  }

  updateSelectedButtonsQuantity() {
    const selectedButtons = this.querySelectorAll('.product-accessory-item__add-btn.selected');
    const mainQuantity = this.getMainProductQuantity();
    
    selectedButtons.forEach(button => {
      button.innerHTML = mainQuantity;
      
      // Animation subtile lors du changement
      button.style.transform = 'scale(1.1)';
      setTimeout(() => {
        button.style.transform = '';
      }, 150);
    });
    
  }

  // 🆕 MÉTHODE PUBLIQUE pour exposer les accessoires sélectionnés
  getSelectedAccessoriesForOptions() {
    const accessories = [];
    const mainQuantity = this.getMainProductQuantity();
    
    this.selectedAccessories.forEach((accessoryData) => {
      accessories.push({
        id: accessoryData.variantId,
        quantity: mainQuantity,
        properties: {
          'Type': 'Accessoire',
          'Produit principal': this.getMainProductTitle()
        }
      });
    });
    
    return accessories;
  }

  // 🆕 MÉTHODE PUBLIQUE pour obtenir les noms des accessoires
  getSelectedAccessoriesNames() {
    return Array.from(this.selectedAccessories.values())
      .map(acc => acc.title)
      .join(', ');
  }

  // 🆕 MÉTHODE PUBLIQUE pour reset après ajout au panier
  resetSelectionsFromOptions() {
    this.resetSelections();
  }

  setupQuantityListener() {
    // Écouter les événements de changement de quantité
    document.addEventListener('quantity:changed', (e) => {
      this.updateSelectedButtonsQuantity();
    });
    
    // Écouter aussi directement les changements sur l'input quantité
    const quantityInput = document.querySelector('quantity-selector .quantity-selector__input');
    const quantityButtons = document.querySelectorAll('quantity-selector .quantity-selector__button');
    
    if (quantityInput) {
      // Input direct
      quantityInput.addEventListener('input', () => {
        setTimeout(() => this.updateSelectedButtonsQuantity(), 50);
      });
      
      // Boutons + et -
      quantityButtons.forEach(button => {
        button.addEventListener('click', () => {
          setTimeout(() => this.updateSelectedButtonsQuantity(), 100);
        });
      });
      
    }
  }
  
  setButtonUnselected(button) {
    button.classList.remove('selected');
    const originalText = this.getOriginalButtonText(button);
    button.innerHTML = originalText;
    button.style.backgroundColor = '';
    button.style.borderColor = '';
    button.style.color = '';
    button.style.animation = '';
  }

  getOriginalButtonText(button) {
    const accessoriesSection = button.closest('.product-accessories');
    return accessoriesSection?.dataset.addButtonText || '+';
  }

  getSelectedAccessories() {
    return Array.from(this.selectedAccessories.values());
  }

  resetSelections() {
    this.selectedAccessories.clear();
    const buttons = this.querySelectorAll('.product-accessory-item__add-btn.selected');
    buttons.forEach(button => this.setButtonUnselected(button));
    
    this.dispatchEvent(new CustomEvent('accessories-changed', {
      detail: {
        selectedCount: 0,
        selectedAccessories: [],
        accessoriesData: []
      },
      bubbles: true
    }));
  }

  listenToMainForm() {
    // 🆕 SI LE SCRIPT OPTIONS EST ACTIF, ne pas intercepter mais rester disponible
    if (window.optionsScriptActive) {
      // 🆕 EXPOSER L'INSTANCE pour que le script options puisse l'utiliser
      window.accessoriesManager = this;
      return; // Ne pas intercepter le formulaire
    }
    
    let mainForm = null;
    
    if (this.mainFormId) {
      mainForm = document.getElementById(this.mainFormId);
    }
    
    if (!mainForm) {
      mainForm = document.querySelector('form[action*="/cart/add"]') ||
                document.querySelector('[data-product-form]') ||
                document.querySelector('product-form form');
    }
    
    if (!mainForm) return;

    if (!mainForm.id) {
      mainForm.id = 'main-product-form-detected';
    }

    const submitHandler = async (e) => {
      if (this.selectedAccessories.size > 0) {
        e.preventDefault();
        e.stopPropagation();
        await this.handleFormSubmissionWithAccessories(mainForm);
        return false;
      }
    };

    mainForm.addEventListener('submit', submitHandler, { capture: true });
    
    const submitButton = mainForm.querySelector('[type="submit"]');
    if (submitButton) {
      submitButton.addEventListener('click', (e) => {
        if (this.selectedAccessories.size > 0) {
          e.preventDefault();
          e.stopPropagation();
          setTimeout(() => {
            this.handleFormSubmissionWithAccessories(mainForm);
          }, 10);
          return false;
        }
      }, { capture: true });
    }
  }

  async handleFormSubmissionWithAccessories(mainForm) {
    try {
      const submitBtn = mainForm.querySelector('[type="submit"]');
      const originalText = submitBtn.textContent;
      
      if (submitBtn) {
        submitBtn.classList.add('loading');
        submitBtn.disabled = true;
        submitBtn.textContent = 'Ajout en cours...';
      }

      const formData = new FormData(mainForm);
      const mainProductData = Object.fromEntries(formData);
      
      const mainQuantity = parseInt(mainProductData.quantity || 1);
      
      const items = [];

      const mainItem = {
        id: parseInt(mainProductData.id),
        quantity: mainQuantity,
        properties: this.extractProperties(mainProductData)
      };
      
      if (this.selectedAccessories.size > 0) {
        const accessoryNames = Array.from(this.selectedAccessories.values())
          .map(acc => acc.title)
          .join(', ');
        mainItem.properties['Accessoires sélectionnés'] = accessoryNames;
      }
      
      items.push(mainItem);

      this.selectedAccessories.forEach((accessoryData) => {
        items.push({
          id: accessoryData.variantId,
          quantity: mainQuantity,
          properties: {
            'Type': 'Accessoire',
            'Produit principal': this.getMainProductTitle()
          }
        });
      });

      const validItems = items.filter(item => 
        item.id && !isNaN(item.id) && item.quantity && item.quantity > 0
      );

      if (validItems.length === 0) {
        throw new Error('Aucun produit valide à ajouter');
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: validItems })
      });

      if (response.ok) {
        this.showSuccessMessage(`${validItems.length} produit${validItems.length > 1 ? 's' : ''} ajouté${validItems.length > 1 ? 's' : ''} au panier`);
        this.resetSelections();
        
        setTimeout(async () => {
          await this.refreshCartDrawer();
        }, 300);
        
      } else {
        const errorData = await response.json();
        throw new Error(errorData.description || `Erreur ${response.status}`);
      }
      
    } catch (error) {
      this.showErrorMessage('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      const submitBtn = mainForm.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.classList.remove('loading');
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      }
    }
  }

  async refreshCartDrawer() {
    try {
      const cartResponse = await fetch('/cart.js');
      const updatedCart = await cartResponse.json();
      
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: updatedCart }
      }));
      
      document.documentElement.dispatchEvent(new CustomEvent('cart:changed', {
        bubbles: true,
        detail: { cart: updatedCart }
      }));
      
      setTimeout(async () => {
        await this.forceCartDrawerReload();
      }, 200);
      
    } catch (error) {
      console.log('Cart refresh error:', error);
    }
  }

  async forceCartDrawerReload() {
    try {
      const response = await fetch(`${window.location.pathname}?section_id=cart-drawer`);
      
      if (response.ok) {
        const html = await response.text();
        const cartDrawer = document.querySelector('cart-drawer, .cart-drawer, [data-cart-drawer]');
        
        if (cartDrawer) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          let newContent = doc.querySelector('cart-drawer .cart-drawer__content') ||
                          doc.querySelector('.cart-drawer__content') ||
                          doc.querySelector('.cart-drawer__inner') ||
                          doc.querySelector('[data-cart-items]');
          
          if (newContent) {
            const currentContent = cartDrawer.querySelector('.cart-drawer__content') || 
                                 cartDrawer.querySelector('.cart-drawer__inner') || 
                                 cartDrawer.querySelector('[data-cart-items]') ||
                                 cartDrawer;
            
            currentContent.innerHTML = newContent.innerHTML;
          }
          
          if (typeof cartDrawer.load === 'function') {
            cartDrawer.load();
          }
        }
      }
    } catch (error) {
      console.error('Force reload failed:', error);
    }
    
    this.updateCartCount();
  }

  updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const countElements = document.querySelectorAll(
          '.cart-count, .header__cart-count, [data-cart-count], .cart-icon__count'
        );
        
        countElements.forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
          el.style.animation = 'cartCountUpdate 0.5s ease';
        });
      })
      .catch(error => {
        console.error('Erreur mise à jour compteur:', error);
      });
  }

  extractProperties(formData) {
    const properties = {};
    Object.keys(formData).forEach(key => {
      if (key.startsWith('properties[')) {
        const propName = key.replace('properties[', '').replace(']', '');
        properties[propName] = formData[key];
      }
    });
    return properties;
  }

  getMainProductTitle() {
    const titleElement = document.querySelector('.product-meta h1, .product__title, h1');
    return titleElement ? titleElement.textContent.trim() : 'Produit principal';
  }

  showSuccessMessage(message) {
    const successDiv = document.createElement('div');
    successDiv.className = 'product-accessories__success';
    successDiv.style.cssText = `
      background: #4CAF50; 
      color: white; 
      padding: 12px 20px; 
      border-radius: 8px; 
      margin: 15px 0;
      text-align: center;
      font-weight: 500;
      animation: slideDown 0.3s ease;
      position: relative;
      z-index: 1000;
    `;
    successDiv.textContent = message;
    
    this.insertBefore(successDiv, this.firstChild);
    
    setTimeout(() => {
      if (successDiv.parentNode) {
        successDiv.style.animation = 'slideUp 0.3s ease';
        setTimeout(() => successDiv.remove(), 300);
      }
    }, 3000);
  }

  showErrorMessage(message) {
    const existingErrors = this.querySelectorAll('.product-accessories__error');
    existingErrors.forEach(error => error.remove());
    
    const errorDiv = document.createElement('div');
    errorDiv.className = 'product-accessories__error';
    errorDiv.style.cssText = `
      background: #ff4444; 
      color: white; 
      padding: 15px 20px; 
      border-radius: 8px; 
      margin: 15px 0;
      text-align: center;
      font-weight: 500;
      animation: slideDown 0.3s ease;
    `;
    errorDiv.textContent = message;
    
    this.insertBefore(errorDiv, this.firstChild);
    
    setTimeout(() => {
      if (errorDiv.parentNode) {
        errorDiv.style.animation = 'slideUp 0.3s ease';
        setTimeout(() => errorDiv.remove(), 300);
      }
    }, 6000);
  }
}

const style = document.createElement('style');
style.textContent = `
  .product-accessory-item__add-btn.selected {
    background-color: #151F34 !important;
    border-color: #151F34 !important;
    color: white !important;
    transform: scale(1.05);
  }

  .product-accessory-item__add-btn {
    transition: all 0.3s ease;
  }

  .product-accessory-item__add-btn:hover:not(.selected) {
    background-color: #f8f9fa;
    border-color: #007acc;
    transform: scale(1.05);
  }

  @keyframes accessorySelected {
    0% { transform: scale(1); }
    50% { transform: scale(1.2); }
    100% { transform: scale(1.05); }
  }

  .product-form__add-button.loading {
    position: relative;
    pointer-events: none;
  }
  
  .product-form__add-button.loading::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 20px;
    height: 20px;
    border: 2px solid transparent;
    border-top: 2px solid currentColor;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    to {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes slideUp {
    from {
      opacity: 1;
      transform: translateY(0);
    }
    to {
      opacity: 0;
      transform: translateY(-10px);
    }
  }

  @keyframes cartCountUpdate {
    0% { transform: scale(1); }
    50% { transform: scale(1.2); background-color: #151F34; color: #fff; }
    100% { transform: scale(1); }
  }

  .product-accessories__success,
  .product-accessories__error {
    font-family: inherit;
    line-height: 1.4;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }
`;
document.head.appendChild(style);